import React from 'react';

import { Typography, TextField } from '@occc-app/design-system';

export const LoyaltyEventConfiguration: React.FC = () => {
  return (
    <>
      <Typography variant='subtitle1' paragraph>
        When They Complete the Loyalty Event
      </Typography>
      <TextField name='loyaltyEvent.eventType' label='Loyalty Event name' margin='none' />
    </>
  );
};
